module.exports = __webpack_public_path__ + "img/AlinoDetect_VideoTower.c5c671ab.webp";